import {
  LogoutOutlined,
  SafetyOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Collapse, Dropdown, Menu, Modal } from "antd";
import jwt_decode from "jwt-decode";
import TweenOne from "rc-tween-one";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { logout, validateConcurrentLogin } from "../../Actions/api";
import Cookies from "js-cookie";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { history } from "../../Helpers/history";

function mapStateToProps(state) {
  return {
    token: state.auth,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    validateConcurrentLogin: (userId, concurrencyLoginStamp) => dispatch(validateConcurrentLogin(userId, concurrencyLoginStamp)),
  };
};

const { Panel } = Collapse;

const fourteenMinutesMS = 840000;

const { confirm } = Modal;

const timeout = () => {
  window.addEventListener('storage', function (event) {
    if (event.key == "logout") {
      setLogout();
      history.push("/Login");
    }
  }, false);
  const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
  ];
  
  const token = Cookies.get('JWToken');
  if(token){
    const resetTimeout = () => {
      clearTimeout(logoutTimeout);
      logoutTimeout = setTimeout(showConfirm, fourteenMinutesMS);
    }
    for(const i in events){
      window.addEventListener(events[i], resetTimeout);
    }
    logoutTimeout = setTimeout(showConfirm, fourteenMinutesMS);
    return () => {
      for(const i in events){
        window.removeEventListener(events[i], resetTimeout);
        clearTimeout(logoutTimeout);
      }
    }
  }
}

const showConfirm = () => {
  let secondsToGo = 60;
  const modal = confirm({
    okText: 'Continue',
    cancelText: 'Logout',
    title: 'Session TimeOut!',
    icon: <ExclamationCircleOutlined />,
    content: `The Current Session is about to expire in ${secondsToGo} seconds.`,
    async onOk() {
      clearTimeout(logoutTimeout);
      clearInterval(timer);
      logoutTimeout = setTimeout(showConfirm, fourteenMinutesMS);
    },
    onCancel() {
      clearTimeout(logoutTimeout);
      clearInterval(timer);
      modal.destroy();
      setLogout();
      history.push("/Login");
    },
  });
  const timer = setInterval(() => {
    secondsToGo -= 1;
    modal.update({
      content: `The Current Session is about to expire in ${secondsToGo} seconds.`,
    });
    if(secondsToGo === 0){
      clearTimeout(logoutTimeout);
      clearInterval(timer);
      modal.destroy();
      setLogout();
      history.push("/Login");
    }
  }, 1000);
}


let logoutTimeout = setTimeout(showConfirm, fourteenMinutesMS);

let setLogout;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneOpen: false,
      loggedOut: false,
      uid: null
    };
    this.logout = this.logout.bind(this);
    this.validateConcurrentLogin = (userId, concurrencyLoginStamp) => this.props.validateConcurrentLogin(userId, concurrencyLoginStamp);
  }

  componentDidMount() {
    setLogout = this.logout;
    clearTimeout(logoutTimeout);
    let token = Cookies.get('JWToken');
    let concurrencyLoginStamp = localStorage.getItem('ConcurrencyLoginStamp');
    if (token && concurrencyLoginStamp) {
      var decodePayload = jwt_decode(token);
      this.validateConcurrentLogin(decodePayload.uid, concurrencyLoginStamp);
      timeout();
    }
  }
  
  phoneClick = () => {
    const phoneOpen = !this.state.phoneOpen;
    this.setState({
      phoneOpen,
    });
  };

  // setLanguage = (language) => {
  //   localStorage.setItem("Language", language);
  //   window.location.reload(false);
  // };

  logout() {
    this.props.logout(); // call logout here from props
    this.setState({ loggedOut: true });
  }

  render() {
    const { dataSource, isMobile, ...props } = this.props;
    const { phoneOpen } = this.state;
    const { LinkMenu } = dataSource;
    const navData = LinkMenu.children;

    const token = Cookies.get("JWToken");

    var username = "";
    if (token) {
      var decoded = jwt_decode(token);
      username = decoded.username;
    }

    const menu = (
      <Menu className="dropdown_menu">
        <Menu.Item>
          <Link to="/Profile">
            <UserOutlined className="dropdown_icon" />
            <span className="menu-item-title">
              <FormattedMessage id="profile" />
            </span>
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/ChangePassword">
            <SafetyOutlined className="dropdown_icon" />
            <span className="menu-item-title">
              <FormattedMessage id="changePassword" />
            </span>
          </Link>
        </Menu.Item>
        <Menu.Item>
          <Link to="/Login" onClick={() => this.logout()}>
            <LogoutOutlined className="dropdown_icon" />
            <span className="menu-item-title">
              <FormattedMessage id="logout" />
            </span>
          </Link>
        </Menu.Item>
      </Menu>
    );

    const menu_mobile = (
      <div className="mobile_user_detail">
        <Collapse
          style={{
            background: "none",
            border: "none",
            marginTop: "5px",
            marginBottom: "0px",
          }}
        >
          <Panel
            header={
              !token ? (
                ""
              ) : (
                <p className="panel_title">
                  <UserOutlined
                    style={{
                      backgroundColor: "white",
                      color: "grey",
                      padding: "5px",
                      borderRadius: "50%",
                      marginRight: "10px",
                    }}
                  />
                  {username}
                </p>
              )
            }
            showArrow={false}
          >
            <p className="panelEachLink">
              <Link to="/Profile">
                <UserOutlined
                  className="dropdown_icon"
                  style={{ margin: "0px 10px 0px 23px" }}
                />
                <span className="menu-item-title">
                  <FormattedMessage id="profile" />
                </span>
              </Link>
            </p>
            <p className="panelEachLink">
              <Link to="/ChangePassword">
                <SafetyOutlined
                  className="dropdown_icon"
                  style={{ margin: "0px 10px 0px 23px" }}
                />
                <span className="menu-item-title">
                  <FormattedMessage id="changePassword" />
                </span>
              </Link>
            </p>
            <p className="panelEachLink">
              <Link to="/Login" onClick={() => this.logout()}>
                <LogoutOutlined
                  className="dropdown_icon"
                  style={{ margin: "0px 10px 0px 23px" }}
                />
                <span className="menu-item-title">
                  <FormattedMessage id="logout" />
                </span>
              </Link>
            </p>
          </Panel>
        </Collapse>
      </div>
    );
    const navChildren = Object.keys(navData).map((key, i) => (
      <Link
        {...navData[key]}
        href={navData[key].href}
        to={navData[key].href}
        target={navData[key].target}
        key={i}
      >
        {navData[key].children}
      </Link>
    ));
    const moment = phoneOpen === undefined ? 300 : null;
    return (
      <TweenOne
        component="header"
        animation={{ opacity: 0, type: "from" }}
        {...dataSource.wrapper}
        id={props.id}
      >
        <div
          {...dataSource.page}
          className={`${dataSource.page.className}${phoneOpen ? " open" : ""}`}
        >
          <TweenOne
            animation={{ x: -30, type: "from", ease: "easeOutQuad" }}
            {...dataSource.logo}
          >
            <Link href="/" to="/">
              <img width="100%" src={dataSource.logo.children} alt="img" />
            </Link>
          </TweenOne>
          {isMobile && (
            <div
              {...dataSource.mobileMenu}
              onClick={() => {
                this.phoneClick();
              }}
            >
              <em />
              <em />
              <em />
            </div>
          )}

          <TweenOne
            {...LinkMenu}
            animation={
              isMobile
                ? {
                  height: 0,
                  duration: 300,
                  onComplete: (e) => {
                    if (this.state.phoneOpen) {
                      e.target.style.height = "auto";
                    }
                  },
                  ease: "easeInOutQuad",
                }
                : null
            }
            moment={moment}
            reverse={!!phoneOpen}
          >
            {navChildren}
            
            {(!token)
              ? 
              //  (window.location.href.indexOf("staging") !== -1) ? 
              // [
              //   <Link
              //     to="/SignUp"
              //     className="menu-item klujrglxnl8-editor_css login move_top"
              //     key={1}
              //   >
              //     <FormattedMessage id="signup" />
              //   </Link>,
              //   <Link
              //     to="/Login"
              //     className="menu-item klujrglxnl8-editor_css login"
              //     key={2}
              //   >
              //     <FormattedMessage id="login" />
              //   </Link>,
              // ] 
              // : 
               [
                 <Link
                 to="/Contact"
                 className="menu-item klujrglxnl8-editor_css login move_top"
                 key={1}
               >
                 <FormattedMessage id="contactUs" />
               </Link>,
               <Link
                 to="/Login"
                 className="menu-item klujrglxnl8-editor_css login"
                 key={2}
               >
                 <FormattedMessage id="login" />
               </Link>,
               ]
               : 
              [
                <Dropdown
                  overlay={menu}
                  key="desktop"
                  placement="bottomCenter"
                  className="user_detail klujhwre4e7-editor_css"
                >
                  <div className="username">
                    <UserOutlined className="icon_Username" /> {username}
                  </div>
                </Dropdown>,
                <span key="mobile">{menu_mobile}</span>,
              ]}
          </TweenOne>
        </div>
      </TweenOne>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
